import { make } from 'vuex-pathify';
import { filter, keyBy, keys, sortBy, values } from 'lodash';

const responses = keyBy(
    [
        {
            id: 1,
            text: 'Have sex without a condom. They’ve been dating for a while and she really likes him, so it’s ok.',
            feedback: 'If Billi has sex without a condom, she’s not maintaining her boundaries. Is there another option that she could try?',
            correct: false,
            selected: false
        },
        {
            id: 2,
            text:
                'Tell Johnny that she’s really into him and wants to have sex, but she won’t do it without a condom. If he’s not willing to wear a condom, then they can do something lower risk, like masturbate in front of each other.',
            feedback: 'Good job! This response helps Billi maintain her boundary.',
            correct: true,
            selected: false
        },
        {
            id: 3,
            text: 'Say to Johnny “You think condoms take the fun out of it? What if I put it on you with my mouth? ;)”',
            feedback: 'Good job! This response helps Billi maintain her boundary.',
            correct: true,
            selected: false
        }
    ],
    'id'
);
const responsesOrder = sortBy(keys(responses), k => parseInt(k));

const state = {
    title: 'Setting Boundaries with Your Boo',
    complete: false,
    sticker: {
        text: 'Couple with heart emoji',
        earned: false,
        image: require('@/assets/stickers/stickers_0011_couple.png')
    },
    bonusSticker: false,
    trophy: false,
    responses,
    responsesOrder,
    comics: [
        require('@/assets/comics/Comic05-1.png'),
        require('@/assets/comics/Comic05-2.png'),
        require('@/assets/comics/Comic05-3.png'),
        require('@/assets/comics/Comic05-4.png'),
        require('@/assets/comics/Comic05-5.png')
    ],
    comic: 0
};
const getters = {
    ...make.getters(state),
    hasUnselectedCorrectResponses: state => {
        return filter(values(state.responses), { selected: false, correct: true }).length > 0;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
